import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";

function roleAssetName(role?: string | null) {
    if (!role) return "";
    const name = role.includes("::") ? role.split("::").pop() || role : role;
    const cleaned = name.replace(/_/g, " ").trim();
    if (!cleaned) return "";
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
}

function cloudinaryRoleSrc(role?: string | null, size = 16) {
    const name = roleAssetName(role);
    if (!name) return "";
    return `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size * 2},w_${size * 2}/v1/valAssets/${name}.png`;
}

export default function RoleIcon(props: {
    role?: string | null;
    icon?: string | null;
    size?: number;
    sx?: any;
}) {
    const size = props.size || 16;
    const label = props.role || "";
    const fallbackSrc = cloudinaryRoleSrc(label, size);
    const [src, setSrc] = useState(props.icon || fallbackSrc);

    useEffect(() => {
        setSrc(props.icon || fallbackSrc);
    }, [props.icon, fallbackSrc]);

    if (!src) return null;

    return (
        <Tooltip title={label} followCursor={true}>
            <Box
                component="img"
                src={src}
                alt={label}
                onError={() => {
                    if (fallbackSrc && src !== fallbackSrc) setSrc(fallbackSrc);
                }}
                sx={{
                    width: size,
                    height: size,
                    minWidth: size,
                    minHeight: size,
                    objectFit: "contain",
                    ...props.sx,
                }}
            />
        </Tooltip>
    );
}
